// import React, { useState } from "react";
// import Dropdown from 'react-bootstrap/Dropdown';
// import { getCountries, getCountryCallingCode, isValidPhoneNumber } from "react-phone-number-input";
// import en from 'react-phone-number-input/locale/en';
// import 'react-phone-number-input/style.css'

// const PhoneNo = ({ sellItem, setSellItem, handlePhone, country, setCountry, isOwner }) => {
//     // const [count, setCount] = useState(country);

//     const CountrySelect = ({ value, labels, ...rest }) => {
//         const [searchCountry, setSearchCountry] = useState('');
//         const filteredCountries = getCountries().filter((country) =>
//             labels[country].toLowerCase().includes(searchCountry.toLowerCase())
//         );
//         const filtercountries = getCountries().filter((country) => labels[country].toLowerCase().includes(searchCountry.toLowerCase()));
//         const filteredCodes = getCountries().filter((country) => getCountryCallingCode(country).includes(searchCountry));
//         return (
//             <Dropdown>
//                 <Dropdown.Toggle variant="default" disabled>
//                     +{getCountryCallingCode(country ? country : 'NL')}
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu>
//                     <div className="col-md-12 position-relative">
//                         <span class="search-icon position-absolute pt-0 ps-0 search-icon-store">
//                             <i class="fa fa-search"></i>
//                         </span>
//                         <input
//                             type="text"
//                             className="form-control"
//                             placeholder="Search Country"
//                             value={searchCountry}
//                             onChange={(e) => setSearchCountry(e.target.value)}
//                             style={{ paddingLeft: '40px' }}
//                         />
//                     </div>
//                 </Dropdown.Menu>
//             </Dropdown>
//         )
//     };

//     return (
//         <div className={'phone-input password position-relative d-flex align-items-center owner-detail-phone-number-wrap'}
//         >
//             <CountrySelect
//                 value={country}
//                 labels={en}
//             />
//             <input defaultCountry={country} 
//             type="number" name="phone_number" 
//             className="form-control" 
//             placeholder="Phone Number" 
//             value={sellItem} 
//             onChange={(e) => handlePhone(e.target.value, isOwner ? 'owner_phone_number' : 'phone_number')} />
//         </div>
//     )
// };

// export default PhoneNo;





import React, { useState, useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import {
  getCountryCallingCode,
  parsePhoneNumber,
} from "react-phone-number-input";
import en from "react-phone-number-input/locale/en";
import nl from "react-phone-number-input/locale/nl";

// Exact same European countries list as your User Component
const europeanCountries = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR",
  "HU", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "NO", "PL", "PT",
  "RO", "SK", "SI", "ES", "SE", "CH", "GB"
];

const PhoneNo = ({ sellItem, setSellItem, handlePhone, country, setCountry, isOwner }) => {
  const { t, i18n } = useTranslation();
  const [searchCountry, setSearchCountry] = useState("");
  const [isDrop, setIsDrop] = useState(false);
  const [displayValue, setDisplayValue] = useState("");
  const inputRef = useRef(null);
  const countryLabels = i18n.language === "nl" ? nl : en;

  // Format phone number for display (national format without country code)
  const formatForDisplay = (digitsOnly, countryCode) => {
    if (!digitsOnly || !countryCode) return digitsOnly || "";

    try {
      const callingCode = getCountryCallingCode(countryCode);
      const fullNumber = `+${callingCode}${digitsOnly}`;
      const phoneNumber = parsePhoneNumber(fullNumber);
      if (phoneNumber && phoneNumber.isValid()) {
        return phoneNumber.formatNational();
      }
    } catch (error) {
      console.log("Formatting error:", error);
    }

    return digitsOnly;
  };

  // Update displayed (formatted) value when sellItem or country changes
  useEffect(() => {
    const formatted = formatForDisplay(sellItem, country || "NL");
    setDisplayValue(formatted);
  }, [sellItem, country]);

  // Handle input: store digits only, display formatted
  const handleInputChange = (value) => {
    const digitsOnly = value.replace(/\D/g, "");
    handlePhone(digitsOnly, isOwner ? "owner_phone_number" : "phone_number");

    const formatted = formatForDisplay(digitsOnly, country || "NL");
    setDisplayValue(formatted);
  };

  // Filter European countries by name or calling code
  const filteredCountries = europeanCountries.filter((c) => {
    // const countryName = en[c].toLowerCase();
    const countryName = (countryLabels[c] || c).toLowerCase();
    const code = getCountryCallingCode(c);
    const term = searchCountry.toLowerCase().replace("+", "");
    return countryName.includes(term) || code.includes(term);
  });

  return (
    <div className="phone-input">
      {/* Country Selector Dropdown */}
      <Dropdown show={isDrop} onToggle={(nextShow) => setIsDrop(nextShow)}>
        <Dropdown.Toggle
          variant="default"
          id="dropdown-country-select"
          className="d-flex align-items-center gap-1 border-0 shadow-none px-2"
          style={{ minWidth: "105px", height: "24px" }}
        >
          {country ? (
            <>
              <img
                src={`https://flagcdn.com/24x18/${country.toLowerCase()}.png`}
                alt={country}
                style={{ width: "28px", height: "21px", borderRadius: "3px" }}
              />
              <span className="fw-medium text-dark">
                +{getCountryCallingCode(country)}
              </span>
              <i className="fa fa-chevron-down text-muted"></i>
            </>
          ) : (
            <span className="text-muted small">
              Select Country
            </span>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{
            maxHeight: "200px",
            overflowY: "scroll",
            marginTop: "7px",
            marginBottom: "27px",
            width: "95%",
          }}
        >
          {/* Search Input */}
          <div className="col-md-12 position-relative px-2 mb-2">
            <span style={{ position: "absolute", left: "20px", top: "9px", zIndex: "10" }}>
              <i className="fa fa-search"></i>
            </span>
            <input
              type="text"
              className="form-control phone-searchinput"
              placeholder={t("phone.searchCountry")}
              value={searchCountry}
              onChange={(e) => setSearchCountry(e.target.value)}
              style={{ paddingLeft: "40px", border: "1px solid #ddd !important" }}
            />
          </div>

          {/* Country List */}
          {filteredCountries.map((c) => (
            <Dropdown.Item
              key={c}
              onClick={() => {
                setCountry(c);
                setIsDrop(false);
                setSearchCountry("");
                // Reformat with new country
                const formatted = formatForDisplay(sellItem, c);
                setDisplayValue(formatted);
              }}
              className="d-flex align-items-center gap-2 px-2"
            >
              <img
                src={`https://flagcdn.com/24x18/${c.toLowerCase()}.png`}
                alt={c}
                style={{ width: "20px", height: "19px", borderRadius: "2px" }}
              />
              {/* <span>{en[c]} (+{getCountryCallingCode(c)})</span> */}
              <span>
                {countryLabels[c] || c} (+{getCountryCallingCode(c)})
              </span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {/* Phone Number Input */}
      <input
        ref={inputRef}
        type="text"
        className="form-control"
        placeholder="06 1234 5678"
        value={displayValue}
        onChange={(e) => handleInputChange(e.target.value)}
      />

      {/* Optional phone icon - uncomment if you want it like the User component */}
      {/* <img
        src={SolarPhone}
        alt="Phone"
        className="position-absolute phone-top-img"
      /> */}
    </div>
  );
};

export default PhoneNo;

